// Cart Bridge JavaScript - Algolia Product Recommendations
// Handles product sliders for recommendations, trending items, and personalization

var collection_handle = '';

const get_products_idx_name = () => {
  const helpers = window.algoliasearch?.helpers;
  if (helpers?.getCurrentProductsIndexName) {
    return helpers.getCurrentProductsIndexName();
  }
  if (helpers?.defaultProductsIndexName) {
    return helpers.defaultProductsIndexName();
  }
  return 'shopify_theoblistproducts';
};

// PDP price alignment: Algolia hits carry ONE variant (often the cheapest),
// so a card can show 200€ while its PDP opens at 550€. ShopifyPriceSync
// (assets/shopify-price-sync.js) re-points every `product-card[handle]` to the
// variant the PDP opens on and re-syncs the price for the active market —
// shared with collections/search. We just trigger it after rendering slides.
const syncBridgeCardPricesToPdp = () => {
  if (window.ShopifyPriceSync) window.ShopifyPriceSync.debouncedSync();
};

const handleTrendingsSlider = async (aiType = "recs") => {
  try {
    console.log('[CART-BRIDGE] handleTrendingsSlider started, aiType:', aiType);
    
    const algolia = window.algoliasearch;
    console.log('[CART-BRIDGE] algoliasearch available:', !!algolia);
    
    if (!algolia) {
      throw new Error('Algoliasearch client not available');
    }
    
    console.log('[CART-BRIDGE] algoliaShopify available:', !!window.algoliaShopify);
    console.log('[CART-BRIDGE] algoliaShopify.shopify:', !!window.algoliaShopify?.shopify);
    console.log('[CART-BRIDGE] algoliaShopify.shopify.market:', !!window.algoliaShopify?.shopify?.market);
    
    if (!algoliaShopify || !algoliaShopify.shopify || !algoliaShopify.shopify.market) {
      throw new Error('algoliaShopify.shopify.market not available');
    }
    
    const helpers = window.algoliasearch?.helpers;
    const current_locale = algoliaShopify.shopify.market.language.shop_locale.locale;
    const current_market = helpers?.normalizeMarketId
      ? helpers.normalizeMarketId(algoliaShopify.shopify.market.id)
      : algoliaShopify.shopify.market.id;
    const market_key = `${current_market}_${current_locale}`;
    const market_region = helpers?.getMarketRegion
      ? helpers.getMarketRegion(market_key, current_locale)
      : (algoliaShopify.config.markets_mapping.find(value => value.key === market_key)?.regions?.[0] || 'FR');
    const currency = market_region === 'US' ? '$' : '€';
    const AL_PRODUCTS_IDX_NAME = helpers?.productsIndexName
      ? helpers.productsIndexName(market_key, current_locale)
      : (helpers?.defaultProductsIndexName?.() || 'shopify_theoblistproducts_united_states_en');

    const client = AlgoliaProxy.searchClient();
    const index = client.initIndex(AL_PRODUCTS_IDX_NAME);

    let attached = false;
    
    let translateX = 0;
    let container, slides, nextArrow, prevArrow;
    
    if(aiType === 'recs'){
      container = document.querySelector('.bridge-recommend-slider');
      slides = document.querySelector('.bridge-recommend-slides');
      nextArrow = document.getElementById('bridge_rec_next');
      prevArrow = document.getElementById('bridge_rec_prev');
    } else if(aiType === 'personalization'){
      container = document.querySelector('.personalized-recs-slider');
      slides = document.querySelector('.personalized-recs-slides');
      nextArrow = document.getElementById('personalized_recs_next');
      prevArrow = document.getElementById('personalized_recs_prev');
    } else {
      container = document.querySelector('.bridge-trending-slider');
      slides = document.querySelector('.bridge-trending-slides');
      nextArrow = document.getElementById('bridge_tred_next');
      prevArrow = document.getElementById('bridge_tred_prev');
    }

    if(!slides) {
      return;
    }
    
    let cardWidth;
    const screenWidth = window.innerWidth;
    const gap = 15; // Gap between cards
    let max;
    
    const recommendclient = AlgoliaProxy.recommendClient();
    let searchQueryID = ''
    let objectIDs = []

    const mapHitToRecsProduct = (hit) => {
      let proUrl = Shopify.routes.root + 'products/' + hit.handle;
      return {
        ...hit,
        handle: hit.handle,
        price: Math.round(hit.price),
        label: hit.title,
        name: hit.title,
        objectID: hit.objectID,
        img: hit.product_image || hit.image || hit.featured_image || 'https://oblist.com/cdn/shop/files/THE_OBLIST_LOGO_WEBSITE_OFFICIAL.png?width=300',
        url: proUrl || hit.handle,
      };
    };
    
    var aisRecsItemsArr = [];
    const aisMaxRecs = 13;
    const aisThreshold = 10;
    const aisShowRecsItems = true;
    let recsQueryId = '';

    let indexName = AL_PRODUCTS_IDX_NAME;

    var threshold = aisThreshold;
    var maxRecommendations = aisMaxRecs;
    
    if(aiType == "recs"){
      let product_handle = localStorage.getItem('ais_product_handle');
      let objectID = localStorage.getItem('ais_product_id');
      
      // Fallback: try to get objectID from cart if not in localStorage
      if (!objectID) {
        console.log('[CART-BRIDGE] No objectID in localStorage, trying to fetch from cart...');
        try {
          const cartResponse = await fetch(`${Shopify.routes.root}cart.js`);
          const cartData = await cartResponse.json();
          if (cartData.items && cartData.items.length > 0) {
            const lastItem = cartData.items[0];
            product_handle = lastItem.handle;
            
            // L'objectID Algolia EST l'ID de variante Shopify : disponible directement
            // dans les données du panier, aucune recherche nécessaire.
            objectID = String(lastItem.variant_id || lastItem.id);
            // Store for future use
            localStorage.setItem('ais_product_id', objectID);
            localStorage.setItem('ais_product_handle', product_handle);
            console.log('[CART-BRIDGE] Found objectID from cart product:', objectID);
          }
        } catch (cartError) {
          console.error('[CART-BRIDGE] Could not get objectID from cart:', cartError);
        }
      }
      
      console.log('[CART-BRIDGE] objectID for recommendations:', objectID);
      console.log('[CART-BRIDGE] product_handle:', product_handle);
      
      if (!objectID) {
        console.error('[CART-BRIDGE] No product objectID found for recommendations');
        document.querySelector('.section-bridge-recommendations')?.style.setProperty('display', 'none');
        throw new Error('No product objectID found for recommendations');
      }
      
      await recommendclient.getRecommendations({
        requests: [
          {
            indexName: indexName,
            objectID: objectID,
            model: 'related-products',
            threshold: threshold,
          },
        ],
      })
      .then(async (response) => {
        const results = response.results[0].hits;
        recsQueryId = response.results[0].queryID || '';
        localStorage.setItem('ais_query_id', recsQueryId);
        
        let filteredResults = algolia?.helpers?.localizeHitData ? results.map(algolia.helpers.localizeHitData) : results;
        
        filteredResults = filteredResults.filter(item => !!item && item.published_at != undefined && item.meta.custom.soldout != true && item.meta.custom.soldout != "true")
        
        aisRecsItemsArr = filteredResults.map(mapHitToRecsProduct);

        if(aisRecsItemsArr.length == 0){
          document.querySelector('.section-bridge-recommendations').style.display = 'none';
          return;
        }

        const productCard_array = aisRecsItemsArr
          .map((product) => {
            objectIDs.push(product.objectID)
            const priceView = algolia?.helpers?.getPriceDisplay ? algolia.helpers.getPriceDisplay(product.currency, product.price) : `${product.currency || '€'} ${(product.price / 100).toFixed(2)}`;
            return `
                  <product-card handle="${product.handle}" data-variant-id="${product.objectID}" class="bridge-card bg-custom text-custom" style="--background: 255 255 255; --text-color: 8 8 13; min-width: 170px; margin-right: 15px;">
                    <!-- Swym Wishlist Plus EPI Button--><div class="product-card__figure">
                        <a href="${product.url}" class="product-bridge-link" data-product-id="${product.objectID}">
                        <img src="${product.img}&width=350"  alt="${product.title}" srcset="${product.img};width=350 350w" width="2460" height="3302" loading="lazy" sizes="(max-width: 699px) calc(100vw / 1 - 40px), (max-width: 999px) calc(100vw / 3 - 64px), calc(min(100vw - 96px, 1300px) / 3 - (24px / 3 * 2))" class="product-card__image product-card__image--primary object-fill-safe aspect-tall">
                        </div><div class="product-card__info "><div class="v-stack gap-0.5 w-full "><h3 class="product-card__title"><a href="${product.url}" class="">${product.name}</a></h3><price-list class="price-list"><sale-price class="text-subdued"><span class="sr-only">Price</span>${priceView}</sale-price></price-list></div></div>
                  </product-card>`;
          })
          .join('');

        slides.innerHTML = productCard_array;
        mapHitsViewedEventProducts(AL_PRODUCTS_IDX_NAME, objectIDs, searchQueryID);
        mapHitClickEventProduct(slides, AL_PRODUCTS_IDX_NAME, 'bridge-recommendation');
        initializeSlider();

        syncBridgeCardPricesToPdp(slides);
      })
      .catch((err) => {
        console.error('[CART-BRIDGE] Error in getRecommendations API call:', err);
        console.error('[CART-BRIDGE] Please configure the "Related Products" recommend model on Algolia Dashboard');
      });
    } 
    else if(aiType=='personalization') {
      const userToken = localStorage.getItem('ais_user_id');
      
      if (!userToken) {
        console.warn('[CART-BRIDGE] No user token found, cannot provide personalized recommendations');
      }
      
      const client = AlgoliaProxy.searchClient();
      const index = client.initIndex(AL_PRODUCTS_IDX_NAME);
      
      await index.search('', {
        analytics: false,
        userToken : userToken, 
        enablePersonalization: true
      }).then(({ hits, queryID }) => {
        searchQueryID = queryID
        let filteredResults = hits.filter(item => item.published_at != undefined && item.meta.custom.soldout != true && item.meta.custom.soldout != "true")
        
        filteredResults = algolia?.helpers?.localizeHitData ? filteredResults.map(algolia.helpers.localizeHitData) : filteredResults;
        aisRecsItemsArr = filteredResults.map(mapHitToRecsProduct);
      });
      
      if(aisRecsItemsArr.length == 0){
        console.warn('[CART-BRIDGE] No personalized recommendations found, hiding section');
        document.querySelector('.section-personalized-recommendations').style.display = 'none';
        return;
      }

      const productCard_array = aisRecsItemsArr
        .map((product) => {
          objectIDs.push(product.objectID)
          const priceView = algolia?.helpers?.getPriceDisplay ? algolia.helpers.getPriceDisplay(product.currency, product.price) : `${product.currency || '€'} ${(product.price / 100).toFixed(2)}`;
          return `
                <product-card handle="${product.handle}" data-variant-id="${product.objectID}" class="bridge-card bg-custom text-custom" style="--background: 255 255 255; --text-color: 8 8 13; min-width: 170px; margin-right: 15px;">
                  <!-- Swym Wishlist Plus EPI Button--><div class="product-card__figure">
                      <a href="${product.url}" class="product-bridge-link" data-product-id="${product.objectID}">
                      <img src="${product.img}&width=350" alt="${product.title}" srcset="${product.img};width=350 350w" width="2460" height="3302" loading="lazy" sizes="(max-width: 699px) calc(100vw / 1 - 40px), (max-width: 999px) calc(100vw / 3 - 64px), calc(min(100vw - 96px, 1300px) / 3 - (24px / 3 * 2))" class="product-card__image product-card__image--primary object-fill-safe aspect-tall">
                      </div><div class="product-card__info "><div class="v-stack gap-0.5 w-full "><h3 class="product-card__title"><a href="${product.url}" class="">${product.name}</a></h3><price-list class="price-list"><sale-price class="text-subdued"><span class="sr-only">Price</span>${priceView}</sale-price></price-list></div></div>
                </product-card>`;
        })
        .join('');

      slides.innerHTML = productCard_array;
      mapHitsViewedEventProducts(AL_PRODUCTS_IDX_NAME, objectIDs, searchQueryID);
      mapHitClickEventProduct(slides, AL_PRODUCTS_IDX_NAME, 'personalization');
      syncBridgeCardPricesToPdp(slides);
    } else {
      const hanlde = collection_handle
      
      if (!hanlde) {
        console.warn('[CART-BRIDGE] No collection handle found for trending items, using global trending');
      }
      
      // Build request - only include facet params if we have a collection handle
      const trendingRequest = {
        indexName: indexName,
        model: 'trending-items',
        threshold: threshold,
        maxRecommendations,
      };
      
      // Only add facet filtering if we have a collection handle
      if (hanlde) {
        trendingRequest.facetName = "collections";
        trendingRequest.facetValue = hanlde;
      }
      
      await recommendclient
      .getRecommendations({
        requests: [trendingRequest],
      })
      .then(async (response) => {
        const results = response.results[0].hits;
        recsQueryId = response.results[0].queryID || '';
        localStorage.setItem('ais_query_id', recsQueryId);
        searchQueryID = recsQueryId
        
        let filteredResults = algolia?.helpers?.localizeHitData ? results.map(algolia.helpers.localizeHitData) : results;
        
        filteredResults = filteredResults.filter(item => !!item && item.published_at != undefined && item.meta.custom.soldout != true && item.meta.custom.soldout != "true");
        
        aisRecsItemsArr = filteredResults.map(mapHitToRecsProduct);

        if(aisRecsItemsArr.length == 0){
          document.querySelector('.section-bridge-trendings').style.display = 'none';
          return;
        }

        const productCard_array = aisRecsItemsArr
          .map((product) => {
            objectIDs.push(product.objectID)
            const priceView = algolia?.helpers?.getPriceDisplay ? algolia.helpers.getPriceDisplay(product.currency, product.price) : `${product.currency || '€'} ${(product.price / 100).toFixed(2)}`;
            return `
                  <product-card handle="${product.handle}" data-variant-id="${product.objectID}" class="bridge-card bg-custom text-custom" style="--background: 255 255 255; --text-color: 8 8 13; min-width: 170px; margin-right: 15px;">
                    <!-- Swym Wishlist Plus EPI Button--><div class="product-card__figure">
                        <a href="${product.url}" class="product-bridge-link" data-product-id="${product.objectID}">
                        <img src="${product.img}&width=350" alt="${product.title}" srcset="${product.img};width=350 350w" width="2460" height="3302" loading="lazy" sizes="(max-width: 699px) calc(100vw / 1 - 40px), (max-width: 999px) calc(100vw / 3 - 64px), calc(min(100vw - 96px, 1300px) / 3 - (24px / 3 * 2))" class="product-card__image product-card__image--primary object-fill-safe aspect-tall">
                        </div><div class="product-card__info "><div class="v-stack gap-0.5 w-full "><h3 class="product-card__title"><a href="${product.url}" class="">${product.name}</a></h3><price-list class="price-list"><sale-price class="text-subdued"><span class="sr-only">Price</span>${priceView}</sale-price></price-list></div></div>
                  </product-card>`;
          })
          .join('');

        slides.innerHTML = productCard_array;
        mapHitsViewedEventProducts(AL_PRODUCTS_IDX_NAME, objectIDs, searchQueryID);
        mapHitClickEventProduct(slides, AL_PRODUCTS_IDX_NAME, 'trending');
        initializeSlider();

        syncBridgeCardPricesToPdp(slides);
      })
      .catch((err) => {
        console.error('[CART-BRIDGE] Error in trending recommendations API call:', err);
        console.error('[CART-BRIDGE] Please configure the "Trending items" recommend model on Algolia Dashboard');
      });
    }

    function updateCardWidth() {
      cardWidth = 170;
    }

    function getPerPage() {
      updateCardWidth();
      return Math.floor(container.clientWidth / (cardWidth + gap));
    }

    function calculateMax() {
      const totalWidth = slides.children.length * (cardWidth + gap);
      const visibleWidth = container.clientWidth;
      return Math.max(0, totalWidth - visibleWidth);
    }

    function updateArrowVisibility() {
    }

    function attachArrows() {
      if(attached) return;
      nextArrow.addEventListener('click', () => {
        if (translateX > -max) {
          translateX = Math.max(translateX - (cardWidth + gap) * getPerPage(), -max);
          slides.style.transform = `translateX(${translateX}px)`;
        }
        updateArrowVisibility();
      });

      prevArrow.addEventListener('click', () => {
        if (translateX < 0) {
          translateX = Math.min(translateX + (cardWidth + gap) * getPerPage(), 0);
          slides.style.transform = `translateX(${translateX}px)`;
        }
        updateArrowVisibility();
      });
      attached = true;
    }

    function setPerPage() {
      updateCardWidth();

      const slideElements = slides.children;
      [...slideElements].forEach((slide) => {
        slide.style.minWidth = `${cardWidth}px`;
        slide.style.marginRight = `${gap}px`;
      });

      max = calculateMax();
    }

    function toggleArrowVisibility() {
      const screenWidth = window.innerWidth;
      const carousel_trendingsBtn = document.getElementById('bridge-trending_btn');
      const carousel_recommendBtn = document.getElementById('bridge-recommend_btn');
      const carousel_personaliBtn = document.getElementById('personalized-recs_btn');

      if (screenWidth < 768) {
        carousel_trendingsBtn.style.display = 'none';
        carousel_recommendBtn.style.display = 'none';
        if(carousel_personaliBtn)
          carousel_personaliBtn.style.display = 'none';
        slides.style.overflowX = 'scroll';
      } else {
        carousel_trendingsBtn.style.display = 'flex';
        carousel_recommendBtn.style.display = 'flex';
        if(carousel_personaliBtn)
          carousel_personaliBtn.style.display = 'flex';
        slides.style.overflowX = 'visible';
      }
      updateArrowVisibility();
    }

    function initializeSlider() {
      updateCardWidth();
      setPerPage();
      toggleArrowVisibility();
      attachArrows();
      updateArrowVisibility();
    }

    window.addEventListener('resize', () => {
      translateX = 0; // Reset translateX on resize to avoid issues
      slides.style.transform = `translateX(${translateX}px)`; // Reset transform
      initializeSlider(); // Re-initialize the slider on window resize
    });

    initializeSlider();
  } catch (error) {
    console.error(`[CART-BRIDGE] Critical error in handleTrendingsSlider (${aiType}):`, error);
    console.error('[CART-BRIDGE] Stack trace:', error.stack);
    
    // Hide relevant sections on error
    if (aiType === 'recs') {
      const section = document.querySelector('.section-bridge-recommendations');
      if (section) section.style.display = 'none';
    } else if (aiType === 'personalization') {
      const section = document.querySelector('.section-personalized-recommendations');
      if (section) section.style.display = 'none';
    } else {
      const section = document.querySelector('.section-bridge-trendings');
      if (section) section.style.display = 'none';
    }
  }
};

const mapHitsViewedEventProducts = (indexname, objectIDs, searchQueryID) => {
  if (!window.aa) {
    console.error('[CART-BRIDGE] Algolia Analytics (aa) not available');
    return;
  }
  
  const userToken = localStorage.getItem("ais_user_id");
  
  aa('viewedObjectIDs', {
    userToken: userToken,
    eventType: 'view',
    eventName: 'Hits Viewed',
    index: indexname,
    queryID: searchQueryID,
    objectIDs: objectIDs.slice(0, 20),
  });
}

const mapHitClickEventProduct = (container, indexName, sourceType = 'bridge-recommendation') => {
  if (!container) {
    console.error('[CART-BRIDGE] No container provided for click events');
    return;
  }

  const links = container.querySelectorAll('.product-bridge-link');

  // Déterminer le nom de l'event selon le type
  let eventName = 'Bridge Recommendation Clicked';
  if (sourceType === 'trending') {
    eventName = 'Bridge Trending Clicked';
  } else if (sourceType === 'personalization') {
    eventName = 'Personalized Recommendation Clicked';
  }

  links.forEach((link, index) => {
    link.addEventListener('click', function (event) {
      const productID = this.getAttribute('data-product-id');

      // Stocker la source pour le tracking Add to Cart
      localStorage.setItem('ais_source', sourceType);
      localStorage.setItem('ais_search_term', '');
      console.log('[CART-BRIDGE] Source stored:', sourceType);

      if (!window.aa) {
        console.error('[CART-BRIDGE] Algolia Analytics (aa) not available for click tracking');
        return;
      }

      const userToken = localStorage.getItem('ais_user_id');
      
      // Send click event to Algolia Insights
      aa('clickedObjectIDs', {
        eventType: 'click',
        eventName: eventName,
        index: indexName,
        objectIDs: [productID],
        userToken: userToken
      });
      console.log('[CART-BRIDGE] Click tracked:', productID, 'Event:', eventName);
    });
  });
}

const retrieveCurrentProduct = async () => {
  try {
    const product_handle = localStorage.getItem('ais_product_handle');
    
    // First, try to get product info from Shopify cart as fallback
    let cartProduct = null;
    try {
      const cartResponse = await fetch(`${Shopify.routes.root}cart.js`);
      const cartData = await cartResponse.json();
      if (cartData.items && cartData.items.length > 0) {
        // Get the last added item (first in array)
        cartProduct = cartData.items[0];
      }
    } catch (cartError) {
      console.warn('[CART-BRIDGE] Could not fetch cart data:', cartError);
    }
    
    // If no product handle in localStorage, use cart product
    if (!product_handle && !cartProduct) {
      console.error('[CART-BRIDGE] No product handle found and cart is empty');
      throw new Error('No product information available');
    }
    
    const urlElement = document.getElementById("just-added-product-url");
    const nameElement = document.querySelector(".product-added-to-cart-name");
    const imageElement = document.querySelector(".product-added-to-cart-image");
    const enhancedTitleElements = document.querySelectorAll("[data-bridge-product-title]");
    
    // Récupérer le record Algolia par objectID (= ID de variante, connu du PDP via
    // localStorage ou du panier) avec getObject : même record que l'ancienne recherche
    // par handle (titre/image/collections identiques) mais sans search request facturée.
    let productHit = null;
    const knownObjectID = localStorage.getItem('ais_product_id')
      || (cartProduct ? String(cartProduct.variant_id || cartProduct.id) : null);
    if (knownObjectID && typeof AlgoliaProxy !== 'undefined' && AlgoliaProxy.getObject) {
      try {
        const indexName = get_products_idx_name();
        const record = await AlgoliaProxy.getObject(indexName, knownObjectID, {
          attributesToRetrieve: 'collections,title,handle,image'
        });
        // Même garde-fou que l'ancien `hits.find(hit => hit.handle === product_handle)` :
        // on n'utilise le record que s'il correspond bien au produit attendu.
        if (record && (!product_handle || record.handle === product_handle)) {
          productHit = record;
          collection_handle = record.collections?.[0] || '';
        }
      } catch (algoliaError) {
        console.warn('[CART-BRIDGE] Algolia getObject failed:', algoliaError);
      }
    }
    
    // Determine which product info to use
    let productTitle, productUrl, productImage;
    
    if (productHit) {
      // Use Algolia data
      productTitle = productHit.title;
      productUrl = Shopify.routes.root + 'products/' + productHit.handle;
      productImage = productHit.image;
    } else if (cartProduct) {
      // Fallback to cart data
      productTitle = cartProduct.product_title;
      productUrl = cartProduct.url;
      productImage = cartProduct.image;
      console.log('[CART-BRIDGE] Using cart product as fallback:', productTitle);
    } else {
      throw new Error('No product data available from any source');
    }
    
    // Update DOM elements
    if (urlElement) {
      urlElement.href = productUrl;
    } else {
      console.error('[CART-BRIDGE] Product URL element not found');
    }
    
    if (nameElement) {
      var addedText = nameElement.getAttribute('data-added-text') || '';
      nameElement.innerHTML = productTitle + (addedText ? ' ' + addedText : '');
    } else {
      console.error('[CART-BRIDGE] Product name element not found');
    }

    if (enhancedTitleElements && enhancedTitleElements.length) {
      enhancedTitleElements.forEach(function (el) {
        el.textContent = productTitle;
      });
    }
    
    if (imageElement && productImage) {
      const imageHtml = `<img src="${productImage}" alt="${productTitle}-image" srcset="${productImage}&width=80 80w, ${productImage}&width=160 160w" width="80" height="auto" loading="lazy" sizes="(max-width: 740px) 80px, 96px" class="line-item__media rounded-xs product-card__image product-card__image--primary object-fill-safe aspect-tall">`;
      imageElement.innerHTML = imageHtml;
    } else if (!productImage) {
      console.warn('[CART-BRIDGE] No product image available');
    } else {
      console.error('[CART-BRIDGE] Product image element not found');
    }
    
  } catch (error) {
    console.error('[CART-BRIDGE] Error in retrieveCurrentProduct:', error);
    console.error('[CART-BRIDGE] Stack trace:', error.stack);
  }
}

// Initialize cart bridge functionality when DOM is ready
const initializeCartBridge = async (customerLoggedIn) => {
  try {
    await retrieveCurrentProduct();
    
    await handleTrendingsSlider();
    
    await handleTrendingsSlider('trendings');
    
    if(customerLoggedIn) {
      await handleTrendingsSlider('personalization');
    }
    
  } catch (error) {
    console.error('[CART-BRIDGE] Critical error during initialization:', error);
    console.error('[CART-BRIDGE] Stack trace:', error.stack);
  }
};

// Make functions available globally for Liquid template
window.initializeCartBridge = initializeCartBridge;